import React from "react";
import "./Clients.css";

const logos = [
  "https://nixxesolutions.com/wp-content/uploads/2023/06/sep-logo_150x150.png",
  "https://assets.goodfirms.co/badges/color-badge/top-software-development-companies.svg",
  "https://nixxesolutions.com/wp-content/uploads/2023/06/9001-2015-c-pv5ekzyz9nujomg86t8dv4ssknmxbx6cy7ahxi2h8w_150x150.jpg",
  "https://nixxesolutions.com/wp-content/uploads/2023/06/pseb_150x150.png",
  "https://nixxesolutions.com/wp-content/uploads/2023/06/pash_150x150.png",
];

const Clients = () => {
  // Duplicate logos for infinite scroll effect
  const doubleLogos = [...logos, ...logos];

  return (
    <section className="client-section">
      <div className="client-header">
        <div className="section-badge">Global Network</div>
        <h2 className="section-title">
          Trusted by <span className="gradient-text">Industry Leaders</span>
        </h2>
      </div>

      <div className="marquee-wrapper">
        <div className="marquee-content">
          {doubleLogos.map((logo, index) => (
            <div key={index} className="client-logo-item">
              <div className="logo-box">
                <img src={logo} alt={`Client ${index}`} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;
